import { rem, rgba } from 'polished';
import styled from 'styled-components';

export const StyledSection = styled.section`
  margin: ${rem('48px')} 0;
  width: 100%;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${rem('32px')};
`;

export const StyledTitle = styled.h2`
  font-size: ${rem('20px')};
  font-weight: 600;
  margin: 0;
`;

export const StyledList = styled.dl`
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
  padding: ${rem('24px')};
  border-radius: ${rem('8px')};
  background-color: ${({ theme }) => theme.colors.main};
  box-shadow: ${({ theme }) =>
    `0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)}`};
  margin-bottom: ${rem('24px')};
`;

export const StyledListGroup = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 32em) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const StyledListTitle = styled.dt`
  font-size: ${rem('16px')};
  font-weight: 700;
`;

export const StyledListDescription = styled.dd`
  font-size: ${rem('16px')};
  margin: 0;
`;

export const StyledButton = styled.button`
  width: 100%;
  padding: ${rem('16px')};
  background-color: transparent;
  border: ${rem('1px')} dashed ${({ theme }) => theme.colors.cross.grayson};
  border-radius: ${rem('8px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('14px')};
  font-weight: 700;
  text-transform: uppercase;
  appearance: none;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => rgba(theme.colors.tenant.mainPale, 0.5)};
    border-color: ${({ theme }) => theme.colors.tenant.main};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const StyledError = styled.p`
  color: ${({ theme }) => theme.colors.cross.red};
`;
